import { BaseAtlas } from './BaseAtlas';

/**
 * Auto-generated class for atlas "spritesheets/cards/backs/33_card_back_deer/33_card_back_deer"
 * Contains 1 texture(s)
 */
export class CardsBacks33CardBackDeerAtlas extends BaseAtlas {
    /**
     * Atlas path
     */
    protected static readonly ATLAS_PATH = 'spritesheets/cards/backs/33_card_back_deer/33_card_back_deer';

    /**
     * List of all available textures in atlas
     */
    protected static readonly TEXTURES = [
        '33_deer.png'
    ] as const;
}
